import React, { Component } from 'react';
import  * as actionCreators  from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form  } from 'formik';
import * as Yup from "yup";
import Spinner from '../Spinner/Spinner';
import apiHelper from '../../api/apiHelper';
import { Button } from 'react-bootstrap';
import Dialog from '../Dialogs/Dialog';
import { Input } from '../FormGroup';
import { api } from '../../api/client';


class ChangeLoginEmail extends Component {

    constructor(props) {
        super(props);
        var me = this;
        me.onSubmitHandler = me.onSubmitHandler.bind(me); 
        me.state = {
            serverError: '',
            //current_email: '',
            //new_email: '',
            user: {
                current_email: '',
                new_email: '',
                isSubmitting : false
            },         
            success: false 
        };

        me.changeLoginEmailSchema = Yup
            .object()
            .shape({
                current_email: Yup                    
                    .string()
                    .label('Current Login Email')
                    .email('Invalid email')
                    .max(256)
                    .required(),
                new_email: Yup
                    .string()
                    .label('New Login Email')
                    .test('match',
                        'New email should be different than current email.',
                        function (emailConfirmation) {
                            if (typeof (emailConfirmation) === 'undefined' && typeof (this.parent.current_email) === 'undefined')
                                return true;
                            return emailConfirmation !== this.parent.current_email;
                        })
                    .email('Invalid email')
                    .max(256)
                    .required(),
                    confirm_new_email: Yup
                    .string()
                    .label('Confirm New Login Email')
                    .test('match',
                        'Confirmation email should be the same as  new email.',
                        function (emailConfirmation) {
                            if (typeof (emailConfirmation) === 'undefined' && typeof (this.parent.current_email) === 'undefined')
                                return true;
                            return emailConfirmation === this.parent.new_email;
                        })
                    .email('Invalid email')
                    .max(256)
                    .required()
            });
    }

    async componentDidMount() {
        const me = this;
        try {
            const userId = me.props.CurrentUser.userId;
            me.setState({ loading: true });
         
            const response = await api.get('users', { params: { id: userId } });
            const responseData = response.data.Data;
 
            const user = {
                current_email: responseData.Email,
                new_email:''
            };

            me.setState({ user });
            me.setState({ loading: false });
        } catch (error) {
            me.setState({ serverError: apiHelper.parseError(error), loading: false });
            console.log(error);
        }
    }


    onSubmitHandler(values ) {
       this.setState({showDialog:true, values});
    }

    handleDialog=()=>{
        this.setState({showDialog:false});
        this.submitData();
    }
    submitData=()=> {
        const values = this.state.values;
        this.setState({isSubmitting: true});

        var me = this;
        var userId = me.props.CurrentUser.userId;
        me.setState({ loading: true });
 
        api.put('users/userName', {
            Id: userId,
            UserName: values.new_email.trim()
        }).then(function (response) {
            const user = {
                current_email: response.data.Email,
                new_email: ''
            };
            me.setState({ user });
            me.setState({ loading: false, isSubmitting: false });

            me.props.history.push('/login');
            me.props.logout();
        })
            .catch(function (error) {
                me.setState({ loading: false, isSubmitting: false, serverError: apiHelper.parseError(error) });
                console.log(error);
            });
    };
     
    render() {
        const serverError = this.state.serverError !== ''
            ? <div
                className='errorMessage'
                style={{
                    marginBottom: 10
                }}>{this.state.serverError}</div>
            : null;

        const spinner = this.state.loading ? <Spinner /> : null;
        const confirmDialog  = this.state.showDialog?  
        <Dialog 
            onClose={this.handleDialog}
            onCancel={ ()=>{  this.setState({showDialog:false})}}
            title="Are you sure you want to update your email address?"
            show={this.state.showDialog}
            showCancelButton
            closeButtonText="OK"
            >
            <span>
                <p>This action will change your login username, and all email from TimePayment will be sent to this new email address. Are you sure you want to update this email address?</p>
            </span>
        </Dialog>
            : null;

        return (
            <React.Fragment>
                {confirmDialog}
                <Formik
                    enableReinitialize
                    initialValues={this.state.user}              
                    validationSchema={this.changeLoginEmailSchema}
                    onSubmit={this.onSubmitHandler}>
                    {({  errors }) => (
                        <Form>
                            <Input
                                name="current_email"
                                label="Current Login Email"
                                disabled={true}
                            />

                            <Input name="new_email" label="New Login Email" />
                            <Input
                                name="confirm_new_email"
                                label="Confirm New Login Email"
                            />  
                            {serverError}
                            {spinner}
                            <div className="button-group">
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    disabled={this.state.isSubmitting || Object.keys(errors).length > 0}
                                  
                                >
                                    Update</Button>
                            </div>
                        </Form >
                    )}

                </Formik>
                <br />
            </React.Fragment>
        )
    }
}

export default connect(state => state.login, dispatch => bindActionCreators(actionCreators, dispatch))(ChangeLoginEmail);